import { type IHttpApiFetchConfig } from '@cian/http-api';

import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IApiGeoGeocodedForSearchRequest,
  type IApiGeoGeocodedForSearchResponse,
  fetchApiGeoGeocodedForSearch,
} from '@/repositories/generated/shared/monolith-cian-realty/api/geo/geocoded-for-search';

import { type IApplicationContext } from '@/microfrontends/filters/shared/types/applicationContext';

import { prepareGeocodedForSearch } from '../mappers/prepareGeocodedForSearch';
import { type TFetchGeocodedForSearchResponse } from '../types/geocodedForSearch';

export const fetchGeocodedForSearch = withTypeSafeApiResult<
  IApiGeoGeocodedForSearchRequest,
  IApiGeoGeocodedForSearchResponse
>(fetchApiGeoGeocodedForSearch);

export async function fetchGeocodedForSearchSafe(
  context: Pick<IApplicationContext, 'httpApi' | 'logger'>,
  parameters: IApiGeoGeocodedForSearchRequest,
  fetchConfig?: IHttpApiFetchConfig,
): Promise<TFetchGeocodedForSearchResponse | null> {
  const data = await fetchGeocodedForSearch(context, parameters, fetchConfig);

  if (data.isErr()) {
    context.logger.warning(`Failed to geocode using 'geocodeForSearch' for: ${JSON.stringify(parameters)}`);
  }

  return data.map(prepareGeocodedForSearch).unwrapOr(null);
}
